import { render } from "./CardBoxComponentFooter.vue?vue&type=template&id=34d2beb8"
const script = {}

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__